import 'core-js/stable';
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import App from './App.vue';
import VueCookies from 'vue-cookies';

import router from './router';
import './plugins/rem';
import Vant from 'vant';
import store from './store';
import 'vant/lib/index.css';
import axios from 'axios';
import VueClipboard from 'vue-clipboard2';
import { Lazyload } from 'vant';
import { CountDown } from 'vant';
import { ImagePreview } from 'vant';
import config from '@/config/config';


import haierSearch from '@/components/haier/index/search';
import haierBanner from '@/components/haier/index/banner';
import lamp from '@/components/haier/index/lamp';
import navtab from '@/components/haier/index/navtab';
import seckill from '@/components/haier/index/seckill';
import haierOptimization from '@/components/haier/index/optimization';
import haiermember from '@/components/haier/index/member';
import recommend from '@/components/haier/index/recommend';
import haierexchangeranking from '@/components/haier/index/exchangeranking';
import { NavBar } from 'vant';
import VueMatomo from 'vue-matomo';
import md5 from 'js-md5';

/*import Vconsole from 'vconsole';

new Vconsole();*/

import TduckForm, { baseConfig } from '@hwork/tduck-form-generator';
//初始化
if (window.Statistics) {
  window.Statistics('init', {
    Vue, //vu3 项目传 Vue 实例， app: app实例
    router,// 路由对象实例
    sentry: {
      dsn: 'https://be8e17f2fee24f03875d60e3b4d82055@ss.haier.net/511', // 替换上报地址
      // 环境信息
      environment: 'prod',  //请配置为 dev 、test、stage、prod 中一种
      // 通过环境变量注入对应版本号
      release: process.env.FRAPPE_VERSION,  // 配置参考 “约定-版本控制约定”
    }
  });
}
const {
  BASE_URL,
  FORM_USER_NAME,
  FORM_USER_ID,
  FORM_USER_TOKEN,
  FORM_USER_PHONE,
  FORM_USER_SOURCE
  // ACCESS_TOKEN
} = baseConfig;


//前端CMS对应的组件要在main.js里注册
Vue.use(NavBar);
Vue.use(haierSearch);
Vue.use(haierBanner);
Vue.use(lamp);
Vue.use(navtab);
Vue.use(seckill);
Vue.use(haierOptimization);
Vue.use(haiermember);
Vue.use(haierexchangeranking);
Vue.use(recommend);
Vue.use(VueCookies);
Vue.use(TduckForm);

localStorage.setItem(BASE_URL, 'https://hwork.haier.net/gw');
// 测试域名
//https://test-hwork.haier.net/gw
// 预生产域名
//https://pre-hwork.haier.net/gw
// 生产域名
//https://hwork.haier.net/gw

Vue.prototype.config = config;
Vue.prototype.$axios = axios;
Vue.prototype.$md5 = md5;

Vue.use(Vant);
Vue.use(VueClipboard);
Vue.use(CountDown);
Vue.use(Lazyload);
Vue.use(ImagePreview);
import EtcButton from './components/etc-button';

// import 'wot-design/lib/theme-default/index.css'


Vue.use(EtcButton);
Vue.use(VueMatomo, {
  // Configure your matomo server and site by providing
  host: 'https://sa.haier.net/piwik',
  siteId: 'jfsc',
  trackerFileName: 'piwik',
  // import 
  router: router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  debug: false
});

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  if (to.path.indexOf('index') > 0) {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
  // window.location.origin !== 'http://localhost:8080' // 本地启动禁止重定向https
  if (window.location.protocol === 'http:' && window.location.hostname !== 'localhost') {
    // 当前是HTTP协议，重定向到HTTPS
    window.location.href = window.location.href.replace('http:', 'https:');
  } else {
    if (to.meta.login == true) {
      if (window.sessionStorage.getItem('UserInfo')) {
        next();
      } else {
        next('/login');
      }
    } else {
      next(); // 确保一定要有next()被调用
    }
  }
});

// const userAgent = navigator.userAgent.toLocaleLowerCase();
// if (userAgent.indexOf("micromessenger") > -1) {
// 	wx.miniProgram.getEnv(res => {
// 		if (res.miniprogram) {
// 			sessionStorage.setItem('navbarShow', false);
// 			init()
// 		} else {
// 			//在微信中
// 			sessionStorage.setItem('navbarShow', true);
//       init()
// 		}
// 	});
// } else {
// 	sessionStorage.setItem('navbarShow', true);
//   init()

// }
// function init() {
// 	new Vue({
// 		store,
// 		router,
// 		render: h => h(App)
// 	}).$mount('#app')
// }
new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app');